import { render, staticRenderFns } from "./PortletVulnerabilityTracker.vue?vue&type=template&id=00c97801"
import script from "./PortletVulnerabilityTracker.vue?vue&type=script&lang=js"
export * from "./PortletVulnerabilityTracker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports